import { dataHooks } from '@wix/data-hooks';

export const navigationDataHooks = dataHooks<{
  root: {};
  menuDropdown: {};
}>('navigation');
